import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { ToastService } from 'src/app/core/services/toast.service';
import { environment } from 'src/environments/environment';

interface Zone {
  id: number;
  nom: string;
  villeId?: number;
  actif: boolean;
}

interface Ville {
  id: number;
  nom: string;
  actif: boolean;
  description?: string;
}

@Component({
  selector: 'app-gestion-villes',
  templateUrl: './gestion-villes.component.html',
  styleUrls: ['./gestion-villes.component.scss']
})
export class GestionVillesComponent implements OnInit {
  villes: Ville[] = [];
  villesFiltrees: Ville[] = [];
  toutes_zones: Zone[] = [];
  recherche = '';
  chargement = false;
  sauvegardeEnCours = false;
  afficherModal = false;
  modeEdition = false;

  formulaire: Partial<Ville> = { nom: '', actif: true, description: '' };
  idEdition: number | null = null;

  private readonly apiUrl = `${environment.apiurl}villes`;

  constructor(private http: HttpClient, private toast: ToastService) {}

  ngOnInit(): void {
    this.charger();
  }

  charger(): void {
    this.chargement = true;
    forkJoin({
      villes: this.http.get<Ville[]>(this.apiUrl),
      zones: this.http.get<any[]>(`${environment.apiurl}zones/actives`)
    }).subscribe({
      next: ({ villes, zones }) => {
        this.villes = Array.isArray(villes) ? villes : [];
        this.toutes_zones = Array.isArray(zones) ? zones : [];
        this.appliquerFiltre();
        this.chargement = false;
      },
      error: () => { this.chargement = false; this.toast.erreur('Impossible de charger les villes'); }
    });
  }

  zonesDeVille(villeId: number): Zone[] {
    return this.toutes_zones.filter(z => z.villeId === villeId);
  }

  appliquerFiltre(): void {
    const q = this.recherche.toLowerCase().trim();
    this.villesFiltrees = q
      ? this.villes.filter(v => v.nom.toLowerCase().includes(q) || (v.description || '').toLowerCase().includes(q))
      : [...this.villes];
  }

  ouvrirCreation(): void {
    this.modeEdition = false;
    this.idEdition = null;
    this.formulaire = { nom: '', actif: true, description: '' };
    this.afficherModal = true;
  }

  ouvrirEdition(v: Ville): void {
    this.modeEdition = true;
    this.idEdition = v.id;
    this.formulaire = { nom: v.nom, actif: v.actif, description: v.description || '' };
    this.afficherModal = true;
  }

  fermerModal(): void { this.afficherModal = false; }

  sauvegarder(): void {
    if (!this.formulaire.nom?.trim()) { this.toast.erreur('Le nom est obligatoire'); return; }
    this.sauvegardeEnCours = true;
    const req$ = this.modeEdition
      ? this.http.put<Ville>(`${this.apiUrl}/${this.idEdition}`, this.formulaire)
      : this.http.post<Ville>(this.apiUrl, this.formulaire);
    req$.subscribe({
      next: () => {
        this.toast.succes(this.modeEdition ? 'Ville mise à jour' : 'Ville créée');
        this.fermerModal();
        this.charger();
        this.sauvegardeEnCours = false;
      },
      error: () => { this.toast.erreur('Erreur lors de l\'enregistrement'); this.sauvegardeEnCours = false; }
    });
  }

  supprimer(v: Ville): void {
    if (!confirm(`Supprimer la ville "${v.nom}" ?`)) return;
    this.http.delete(`${this.apiUrl}/${v.id}`).subscribe({
      next: () => { this.toast.succes('Ville supprimée'); this.charger(); },
      error: () => this.toast.erreur('Impossible de supprimer cette ville')
    });
  }

  get actives(): number { return this.villes.filter(v => v.actif).length; }
  get inactives(): number { return this.villes.filter(v => !v.actif).length; }
}
